/* MENU STICKY */
document.addEventListener("DOMContentLoaded", function () {

    const header = document.querySelector('.header-section');
    if (!header) return;

    const placeholder = document.createElement('div');
    placeholder.classList.add('header-placeholder');
    header.parentNode.insertBefore(placeholder, header);

    const headerHeight = header.offsetHeight;

    window.addEventListener('scroll', function () {
        if (window.scrollY > header.offsetTop) {

            header.classList.add('is-sticky');
            placeholder.style.height = headerHeight + 'px';

        } else {

            header.classList.remove('is-sticky');
            placeholder.style.height = '0px';

        }
    });

});

/* CATEGORIAS */
document.addEventListener("DOMContentLoaded", function(){

    function initSlider($slider, config){
        if(!$slider.length) return;

        if(!$slider.hasClass('slick-initialized')){
            $slider.slick(config);
        }

        setTimeout(() => {
            if($slider.hasClass('slick-initialized')){
                $slider.slick('setPosition');
            }
        }, 50);
    }

    function destroySlider($slider){
        if($slider.length && $slider.hasClass('slick-initialized')){
            $slider.slick('unslick');
        }
    }

    function getSliderConfig(){
        return {
            slidesToShow: 1.8,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: true,
            autoplay: true,
            centerMode: true,
            adaptiveHeight: false
        };
    }

    function handleSlider($container){
        if(!$container.length) return;

        const $slider = $container.find('.js-showcase-slider');

        if(window.innerWidth <= 768){
            initSlider($slider, getSliderConfig());
        } else {
            destroySlider($slider);
        }
    }

    function activateTab(collection){
        $('.copilot-badge').removeClass('is-active');
        $('.copilot-badge[data-collection="' + collection + '"]').addClass('is-active');

        $('.copilot-products').removeClass('is-visible');
        const $activeTab = $('.copilot-products[data-products="' + collection + '"]');
        $activeTab.addClass('is-visible');

        handleSlider($activeTab);
    }

    // CLICK EN TABS
    $('.copilot-badge').on('click', function(){
        const collection = $(this).data('collection');
        activateTab(collection);
    });

    // INIT INICIAL
    setTimeout(() => {
        let $initialTab = $('.copilot-products.is-visible').first();

        // fallback: usar el badge activo
        if(!$initialTab.length){
            const initialCollection = $('.copilot-badge.is-active').data('collection');
            if(initialCollection){
                $initialTab = $('.copilot-products[data-products="' + initialCollection + '"]').first();
                $initialTab.addClass('is-visible');
            }
        }

        if($initialTab.length){
            handleSlider($initialTab);
        }
    }, 100);

    // BONUS: resize optimizado
    let resizeTimer;

    window.addEventListener('resize', function(){
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(() => {
            const $visibleTab = $('.copilot-products.is-visible').first();
            const $visibleSlider = $visibleTab.find('.js-showcase-slider');

            if(window.innerWidth <= 768){
                handleSlider($visibleTab);
            } else {
                destroySlider($visibleSlider);
            }
        }, 200);
    });

    // por si hay imágenes que terminan de cargar después
    $(window).on('load', function(){
        const $visibleSlider = $('.copilot-products.is-visible .js-showcase-slider');
        if($visibleSlider.hasClass('slick-initialized')){
            $visibleSlider.slick('setPosition');
        }
    });

});

/* LOGOS MARQUESINA*/
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth > 768) return;

  var container = document.getElementById('cop-marca-tit-2');
  if (!container) return;

  // Duplicar los items para el loop infinito
  var items = container.querySelectorAll('.nested-block--image');
  items.forEach(function (item) {
    container.appendChild(item.cloneNode(true));
  });

  // Calcular el ancho total de los items originales
  var totalWidth = 0;
  var originalItems = container.querySelectorAll('.nested-block--image');
  var half = originalItems.length / 2;
  for (var i = 0; i < half; i++) {
    totalWidth += originalItems[i].offsetWidth;
  }

  // Aplicar animación CSS dinámica
  var style = document.createElement('style');
  style.innerHTML = `
    @media (max-width: 768px) {
      #cop-marca-tit-2 {
        animation: bihotz-marquee 12s linear infinite !important;
        flex-wrap: nowrap !important;
        will-change: transform;
      }
      @keyframes bihotz-marquee {
        0%   { transform: translateX(0); }
        100% { transform: translateX(-` + totalWidth + `px); }
      }
    }
  `;
  document.head.appendChild(style);
});

/* COMO FUNCIONA */
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth > 768) return;

  var section = document.querySelector('.como-funciona-body');
  if (!section || typeof $.fn.slick === 'undefined') return;

  var $section = $(section);
  var $items = $section.children('.layout-block--container');

  var $slickWrapper = $('<div class="como-funciona-slick"></div>');
  $items.detach().appendTo($slickWrapper);
  $section.append($slickWrapper);

  $slickWrapper.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '0px',
    infinite: true,
    arrows: true,
    dots: false,
    speed: 400,
    cssEase: 'ease'
  });
});

/* BUTTONS COLLECTIONS NAVIGATION */
document.addEventListener('DOMContentLoaded', function () {

  function setActiveButtons() {
    const currentPath = window.location.pathname.replace(/\/$/, '');
    const buttons = document.querySelectorAll('.cop-coll-bad .button');

    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      try {
        const btnPath = new URL(btn.href, window.location.origin)
          .pathname
          .replace(/\/$/, '');

        if (currentPath === btnPath) {
          btn.classList.add('active');
        }
      } catch (e) {}
    });
  }

  setActiveButtons();

  function moveWeglot() {
    const headerWeglot = document.getElementById('weglot_here');
    const weglotContainer = document.querySelector('.weglot-container');

    if (!headerWeglot || !weglotContainer) return;

    // ya está bien colocado → salir
    if (headerWeglot.contains(weglotContainer)) return;

    // mover
    headerWeglot.appendChild(weglotContainer);

    // limpiar duplicados
    document.querySelectorAll('.weglot-container').forEach(function (el) {
      if (el !== weglotContainer) {
        el.style.display = 'none';
      }
    });

    console.log('✅ Weglot movido correctamente');
  }

  const observer = new MutationObserver(function (mutations) {
    let shouldRun = false;

    for (const m of mutations) {
      if (m.addedNodes.length || m.type === 'attributes') {
        shouldRun = true;
        break;
      }
    }

    if (shouldRun) {
      moveWeglot();
      setActiveButtons();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: false // importante: evitar loops innecesarios
  });


  /* =========================
     FALLBACK (por si Shopify rompe todo)
  ========================== */
  let attempts = 0;
  const maxAttempts = 50;

  const interval = setInterval(function () {
    moveWeglot();

    attempts++;
    if (attempts >= maxAttempts) {
      clearInterval(interval);
    }
  }, 200);

});

/* MOVE TO LEFT BTN CONCERT */
document.addEventListener('DOMContentLoaded', function () {
  function movePrivacyButton() {
    var btnel = document.getElementById('uc-main-dialog');
    
    if (!btnel) {
      var host = document.getElementById('usercentrics-cmp-ui');
      if (host && host.shadowRoot) {
        btnel = host.shadowRoot.querySelector('#uc-main-dialog');
      }
    }

    if (!btnel || btnel.classList.contains('left')) {
      return;
    }

    btnel.classList.remove('right');
    btnel.classList.add('left');

    console.log('boton movido')
  }

  movePrivacyButton();

  var observer = new MutationObserver(function () {
    movePrivacyButton();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true
  });

  setInterval(movePrivacyButton, 100);
});

/* FORM VALIDATION */
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".contact-form__form").forEach(form => {

    form.addEventListener("submit", function (e) {

      let isValid = true;

      // limpiar errores previos
      form.querySelectorAll(".field-error").forEach(el => el.remove());
      form.querySelectorAll(".error").forEach(el => el.classList.remove("error"));

      // inputs requeridos
      const requiredFields = form.querySelectorAll("[aria-required='true'], [required]");

      requiredFields.forEach(field => {

        const value = field.value.trim();

        if (!value) {
          isValid = false;
          showError(field, "Este campo es obligatorio");
        }

        // validación email
        if (field.type === "email" && value) {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(value)) {
            isValid = false;
            showError(field, "Email inválido");
          }
        }
      });

      // checkbox privacidad
      const privacy = form.querySelector("input[type='checkbox'][name*='privacy']");
      if (privacy && !privacy.checked) {
        isValid = false;
        showError(privacy, "Debes aceptar la política");
      }

      if (!isValid) {
        e.preventDefault();
      }

    });

    function showError(field, message) {
      field.classList.add("error");

      const error = document.createElement("div");
      error.className = "field-error";
      error.innerText = message;

      if (field.type === "checkbox") {
        field.closest(".contact-form__form-row").appendChild(error);
      } else {
        field.parentNode.appendChild(error);
      }
    }

  });
});

/* SLIDER FOLD SLIDER */
jQuery(document).ready(function($) {

  const $slider = $('.js-mobile-slider');

  function initSlider() {
    if ($(window).width() <= 768) {

      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          autoplay: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          infinite: true,
          adaptiveHeight: false
        });
      }

    } else {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    }
  }

  initSlider();
  $(window).on('resize', initSlider);

});

/* SLIDER SACALECHES */
jQuery(document).ready(function($) {

  //const $slider = $('.copilot-features__grid');
  const $slider = $('.copilot-features__grid').not('body.guia-del-sueno .copilot-features__grid');

  const prevArrow = `
      <svg xmlns="http://www.w3.org/2000/svg" class="slick-prev" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <circle cx="14" cy="14.0001" r="14" transform="rotate(90 14 14.0001)" fill="#A25157"/>
        <path d="M13.4032 13.5012L15.9982 16.2549L15.2962 17.0001L12 13.5012L15.298 10.0001L16 10.7452L13.4032 13.5012Z" fill="white"/>
      </svg>
  `;

  const nextArrow = `
      <svg xmlns="http://www.w3.org/2000/svg" class="slick-next" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <circle cx="14" cy="14" r="14" transform="rotate(-90 14 14)" fill="#A25157"/>
        <path d="M14.5968 14.4988L12.0018 11.7451L12.7038 11L16 14.4988L12.702 18L12 17.2549L14.5968 14.4988Z" fill="white"/>
      </svg>
  `;

  function initSlider() {
    if ($(window).width() <= 768) {

      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          infinite: true,
          adaptiveHeight: false,
          prevArrow: prevArrow,
          nextArrow: nextArrow
        });
      }

    } else {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    }
  }

  initSlider();
  $(window).on('resize', initSlider);

});

/* SLIDER PASOS SACALECHES */
jQuery(document).ready(function($) {

  const $slider = $('.copilot-diferencia-module-body');

  const prevArrow = `
      <svg xmlns="http://www.w3.org/2000/svg" class="slick-prev" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <circle cx="14" cy="14.0001" r="14" transform="rotate(90 14 14.0001)" fill="#A25157"/>
        <path d="M13.4032 13.5012L15.9982 16.2549L15.2962 17.0001L12 13.5012L15.298 10.0001L16 10.7452L13.4032 13.5012Z" fill="white"/>
      </svg>
  `;

  const nextArrow = `
      <svg xmlns="http://www.w3.org/2000/svg" class="slick-next" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <circle cx="14" cy="14" r="14" transform="rotate(-90 14 14)" fill="#A25157"/>
        <path d="M14.5968 14.4988L12.0018 11.7451L12.7038 11L16 14.4988L12.702 18L12 17.2549L14.5968 14.4988Z" fill="white"/>
      </svg>
  `;

  function initSlider() {
    if ($(window).width() <= 768) {

      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          infinite: true,
          centerMode: false,
          adaptiveHeight: true,
          prevArrow: prevArrow,
          nextArrow: nextArrow
        });
      }

    } else {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    }
  }

  initSlider();
  $(window).on('resize', initSlider);

});

/* SLIDER Tendendias SACALECHES */
jQuery(document).ready(function($) {

  const $slider = $('.tendencia-body-module');

  const prevArrow = `
      <svg xmlns="http://www.w3.org/2000/svg" class="slick-prev" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <circle cx="14" cy="14.0001" r="14" transform="rotate(90 14 14.0001)" fill="#A25157"/>
        <path d="M13.4032 13.5012L15.9982 16.2549L15.2962 17.0001L12 13.5012L15.298 10.0001L16 10.7452L13.4032 13.5012Z" fill="white"/>
      </svg>
  `;

  const nextArrow = `
      <svg xmlns="http://www.w3.org/2000/svg" class="slick-next" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <circle cx="14" cy="14" r="14" transform="rotate(-90 14 14)" fill="#A25157"/>
        <path d="M14.5968 14.4988L12.0018 11.7451L12.7038 11L16 14.4988L12.702 18L12 17.2549L14.5968 14.4988Z" fill="white"/>
      </svg>
  `;

  function initSlider() {
    if ($(window).width() <= 768) {

      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          infinite: true,
          centerMode: false,
          adaptiveHeight: true,
          prevArrow: prevArrow,
          nextArrow: nextArrow
        });
      }

    } else {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    }
  }

  initSlider();
  $(window).on('resize', initSlider);

});

/* SLIDER SEIS FRENTES */
jQuery(document).ready(function($) {

  const $slider = $('.seis-frentes-body');

  const prevArrow = `
      <svg xmlns="http://www.w3.org/2000/svg" class="slick-prev" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <circle cx="14" cy="14.0001" r="14" transform="rotate(90 14 14.0001)" fill="#A25157"/>
        <path d="M13.4032 13.5012L15.9982 16.2549L15.2962 17.0001L12 13.5012L15.298 10.0001L16 10.7452L13.4032 13.5012Z" fill="white"/>
      </svg>
  `;

  const nextArrow = `
      <svg xmlns="http://www.w3.org/2000/svg" class="slick-next" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <circle cx="14" cy="14" r="14" transform="rotate(-90 14 14)" fill="#A25157"/>
        <path d="M14.5968 14.4988L12.0018 11.7451L12.7038 11L16 14.4988L12.702 18L12 17.2549L14.5968 14.4988Z" fill="white"/>
      </svg>
  `;

  function initSlider() {
    if ($(window).width() <= 768) {

      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          infinite: false,
          centerMode: false,
          adaptiveHeight: true,
          prevArrow: prevArrow,
          nextArrow: nextArrow
        });
      }

    } else {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    }
  }

  initSlider();
  $(window).on('resize', initSlider);

});

/* SLIDER CUANTOS HAY */
jQuery(document).ready(function($) {

  const $slider = $('.cuantos-hay-module-mobile');

  const prevArrow = `
      <svg xmlns="http://www.w3.org/2000/svg" class="slick-prev" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <circle cx="14" cy="14.0001" r="14" transform="rotate(90 14 14.0001)" fill="#A25157"/>
        <path d="M13.4032 13.5012L15.9982 16.2549L15.2962 17.0001L12 13.5012L15.298 10.0001L16 10.7452L13.4032 13.5012Z" fill="white"/>
      </svg>
  `;

  const nextArrow = `
      <svg xmlns="http://www.w3.org/2000/svg" class="slick-next" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <circle cx="14" cy="14" r="14" transform="rotate(-90 14 14)" fill="#A25157"/>
        <path d="M14.5968 14.4988L12.0018 11.7451L12.7038 11L16 14.4988L12.702 18L12 17.2549L14.5968 14.4988Z" fill="white"/>
      </svg>
  `;

  function initSlider() {
    if ($(window).width() <= 768) {

      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          infinite: true,
          centerMode: false,
          adaptiveHeight: true,
          prevArrow: prevArrow,
          nextArrow: nextArrow
        });
      }

    } else {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    }
  }

  initSlider();
  $(window).on('resize', initSlider);

});

/* DISCOUNT PRICE APOSITOS */
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.variant-option__button-label__text').forEach(span => {
    span.innerHTML = span.textContent.replace(
      /(-\d+% OFF)/g,
      '<strong style="color: #A25157;">$1</strong>'
    );
  });
});

/* SLIDER LANDING COURSE */
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.es-para-ti-module-body');

  if (!slider) return;

  function initMobileSlick() {
    const isMobile = window.innerWidth <= 768;

    if (isMobile && !$(slider).hasClass('slick-initialized')) {
      $(slider).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        adaptiveHeight: true
      });
    }

    if (!isMobile && $(slider).hasClass('slick-initialized')) {
      $(slider).slick('unslick');
    }
  }

  initMobileSlick();

  window.addEventListener('resize', function () {
    initMobileSlick();
  });
});

/* SLIDER LANDING COURSE */
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.body-lecciones-module');

  if (!slider) return;

  function initMobileSlick() {
    const isMobile = window.innerWidth <= 768;

    if (isMobile && !$(slider).hasClass('slick-initialized')) {
      $(slider).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        adaptiveHeight: true,
        centerMode: true,
        centerPadding: 20
      });
    }

    if (!isMobile && $(slider).hasClass('slick-initialized')) {
      $(slider).slick('unslick');
    }
  }

  initMobileSlick();

  window.addEventListener('resize', function () {
    initMobileSlick();
  });
});

/* JUDGE.ME: PRIORITIZE REVIEWS WITH COMMENTS & INCLUDE MYBUSINESS COUNT IN NURSICARE */
(function () {
  var NURSICARE_PRODUCT_ID = '15502871232836';

  function stripHtml(html) {
    return (html || '').replace(/<[^>]+>/g, '').trim();
  }

  function isEmptyReviewText(text) {
    var clean = stripHtml(text).replace(/\s+/g, '');
    return clean === '' || /^[\.\-:;,_]+$/.test(clean);
  }

  function hasValidComment(review) {
    if (!review) return false;
    var body = review.body || review.body_html || '';
    var title = review.title || '';
    return !isEmptyReviewText(body) || !isEmptyReviewText(title);
  }

  function sortReviewsWithCommentsFirst(reviews) {
    if (!Array.isArray(reviews)) return reviews;
    return reviews.slice().sort(function (a, b) {
      var aValid = hasValidComment(a) ? 1 : 0;
      var bValid = hasValidComment(b) ? 1 : 0;
      return bValid - aValid;
    });
  }

  function configureJudgeMeDefaults() {
    if (window.jdgmSettings) {
      window.jdgmSettings.most_relevant_sort_enabled = true;
      window.jdgmSettings.default_sort_method = 'most-relevant';
      window.jdgmSettings.all_reviews_widget_v2025_default_sort_method = 'most-relevant';
    }

    // Sumar las reseñas importadas de Google My Business (Store Reviews) al widget de Nursicare
    var nursicareWidgetData = window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget && window.jdgm.data.reviewWidget[NURSICARE_PRODUCT_ID];
    if (nursicareWidgetData && !nursicareWidgetData._myBusinessMerged) {
      var widgetEl = document.querySelector('.jdgm-widget[data-product-id="' + NURSICARE_PRODUCT_ID + '"]');
      var shopReviewsCount = parseInt(widgetEl && widgetEl.dataset && widgetEl.dataset.shopReviewsCount, 10) || 628;
      var currentCount = parseInt(nursicareWidgetData.number_of_reviews, 10) || 0;

      if (currentCount < shopReviewsCount) {
        var totalCombined = currentCount + shopReviewsCount;
        nursicareWidgetData.number_of_reviews = totalCombined;
        nursicareWidgetData.review_count = totalCombined;
        if (Array.isArray(nursicareWidgetData.histogram) && nursicareWidgetData.histogram[0]) {
          nursicareWidgetData.histogram[0].frequency = (parseInt(nursicareWidgetData.histogram[0].frequency, 10) || currentCount) + shopReviewsCount;
        }
        if (nursicareWidgetData.pagination) {
          var perPage = parseInt(nursicareWidgetData.pagination.per_page, 10) || 5;
          nursicareWidgetData.pagination.total_count = totalCombined;
          nursicareWidgetData.pagination.total_pages = Math.ceil(totalCombined / perPage);
        }
      }
      if (Array.isArray(nursicareWidgetData.reviews)) {
        nursicareWidgetData.reviews = sortReviewsWithCommentsFirst(nursicareWidgetData.reviews);
      }
      nursicareWidgetData._myBusinessMerged = true;
    }
  }

  // Interceptar respuestas de Judge.me CDN para priorizar reseñas con comentario y filtrar vacías en carruseles
  if (typeof window.fetch === 'function' && !window._copilotJdgmFetchWrapped) {
    window._copilotJdgmFetchWrapped = true;
    var originalFetch = window.fetch;

    window.fetch = function (input, init) {
      var originalUrl = typeof input === 'string' ? input : (input && input.url ? input.url : '');
      var url = originalUrl;

      if (url && url.indexOf('judge.me/reviews/') !== -1) {
        // En Nursicare, al paginar o reordenar reseñas de producto, cargar las reseñas de Google My Business (shop-reviews)
        if (url.indexOf('reviews_for_widget') !== -1 && url.indexOf('product_id=' + NURSICARE_PRODUCT_ID) !== -1 && url.indexOf('page=1&') === -1 && !/[?&]page=1$/.test(url)) {
          url = url
            .replace('reviews/reviews_for_widget', 'reviews/all_reviews_js_based')
            .replace('product_id=' + NURSICARE_PRODUCT_ID, 'review_type=shop-reviews&widget_type=review-widget&require_json=true');
        }

        // Si pide reseñas con el orden por defecto (created_at o sin sort_by), usar most_relevant para traer primero las que tienen comentario
        if (url.indexOf('all_reviews_js_based') !== -1 && (url.indexOf('sort_by=created_at') !== -1 || url.indexOf('sort_by=') === -1)) {
          if (url.indexOf('sort_by=created_at') !== -1) {
            url = url.replace('sort_by=created_at', 'sort_by=most_relevant');
          } else {
            url += (url.indexOf('?') !== -1 ? '&' : '?') + 'sort_by=most_relevant';
          }
        }

        var fetchInput = input;
        if (url !== originalUrl) {
          fetchInput = (typeof input === 'string') ? url : new Request(url, input);
        }

        return originalFetch.call(this, fetchInput, init).then(function (response) {
          if (!response || !response.ok) return response;
          var clone = response.clone();
          return clone.json().then(function (data) {
            if (!data || !Array.isArray(data.reviews)) return response;

            if (url.indexOf('reviews_for_carousel') !== -1) {
              data.reviews = data.reviews.filter(hasValidComment);
            } else {
              data.reviews = sortReviewsWithCommentsFirst(data.reviews);
            }

            return new Response(JSON.stringify(data), {
              status: response.status,
              statusText: response.statusText,
              headers: response.headers
            });
          }).catch(function () {
            return response;
          });
        });
      }

      return originalFetch.apply(this, arguments);
    };
  }

  configureJudgeMeDefaults();

  document.addEventListener('DOMContentLoaded', function () {
    configureJudgeMeDefaults();

    function processJudgeMeDOM() {
      // 1. Carrusel de tarjetas (.jdgm-card): eliminar tarjetas vacías o solo con signos
      document.querySelectorAll('.jdgm-card').forEach(function (card) {
        var textElement = card.querySelector('.jdgm-text');
        if (!textElement) return;
        if (isEmptyReviewText(textElement.textContent)) {
          card.remove();
        }
      });

      // 2. Widget de reseñas v3 Revamp (.jm-review-item) y Legacy (.jdgm-rev): enviar sin comentario al final
      document.querySelectorAll('.jdgm-review-list, .jdgm-rev-widg__reviews').forEach(function (list) {
        var items = Array.prototype.slice.call(list.children);
        items.forEach(function (item) {
          if (!item.classList.contains('jm-review-item') && !item.classList.contains('jdgm-rev')) return;
          var bodyEl = item.querySelector('.jm-review-content__body, .jdgm-rev__body');
          var titleEl = item.querySelector('.jm-review-content__title, .jdgm-rev__title');
          var bodyText = bodyEl ? bodyEl.textContent : '';
          var titleText = titleEl ? titleEl.textContent : '';

          if (isEmptyReviewText(bodyText) && isEmptyReviewText(titleText)) {
            item.classList.add('copilot-empty-review');
            if (list.lastElementChild !== item) {
              list.appendChild(item);
            }
          }
        });
      });
    }

    var observer = new MutationObserver(function () {
      processJudgeMeDOM();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    processJudgeMeDOM();
  });
})();